// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ie-3";
export var downloadButton = "_ie-4";
export var fileContainer = "_ie-9 _ie-7";
export var fileContainerBase = "_ie-7";
export var fileContainerFixedHeight = "_ie-8 _ie-7";
export var fileInfo = "_ie-5";
export var fileInfoWidthRestricted = "_ie-6";
export var fileType = "_ie-1";
export var fileTypeName = "_ie-2";
export var image = "_ie-0";
export var link = "_ie-b";
export var overflowEllipsis = "_ie-a";